import React from "react";
import getLowResLink from "../../../../utils/get-low-res-link";
import { S3 } from "../../../../constants";

class Picture extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      src: null,
    };
  }

  loadImage() {
    const { src = "" } = this.props;
    const srcLowRes = getLowResLink(src);
    const loadActions = (src) => {
      return () => this.setState({ src: S3.toCDN(src) });
    };
    const errorHandler = (event) => {
      event.onerror = null;
      imageLoader.src = src;
      imageLoader.onload = loadActions(src);
      imageLoader.removeEventListener("error", errorHandler);
    };

    const imageLoader = new Image();
    imageLoader.src = srcLowRes;
    imageLoader.onload = loadActions(srcLowRes);
    imageLoader.addEventListener("error", errorHandler);
  }

  componentDidMount() {
    if (this.props.loaded && this.props.src) this.loadImage();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.src !== this.props.src ||
      prevProps.loaded !== this.props.loaded
    ) {
      if (!this.props.src) {
        this.setState({
          src: null,
        });
        return;
      }
      this.loadImage();
    }
  }

  render() {
    const { src } = this.state;
    const {
      loaded,
      toggleModal,
      photoType,
      className = "picture-item",
    } = this.props;
    return (
      <div
        className={className}
        onClick={() => {
          if (loaded && src) toggleModal(this.props.src, photoType);
        }}
        style={
          loaded && src
            ? {
                backgroundImage: `url("${src}")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                cursor: "pointer",
              }
            : {}
        }
      />
    );
  }
}

export default Picture;
